"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
require("document-register-element");
var React = require("react");
var ReactDOM = require("react-dom");
var Pvjs_1 = require("../Pvjs");
var lodash_1 = require("lodash");
/**
 * A custom HTML element for WikiPathways Diagrams
 * See this guide: https://developers.google.com/web/fundamentals/getting-started/primers/customelements
 */
var CustomElement = (function (_super) {
    __extends(CustomElement, _super);
    function CustomElement() {
        var _this = _super.call(this) || this;
        _this.onReady = function (entities) {
            _this.entities = entities;
            _this.setAttribute('ready', '');
            var readyEvent = new CustomEvent('ready', {
                detail: { entities: entities }
            });
            _this.dispatchEvent(readyEvent);
        };
        return _this;
    }
    Object.defineProperty(CustomElement, "observedAttributes", {
        get: function () {
            return ['wp-id', 'version', 'show-pan-zoom-controls', 'detail-panel-enabled',
                'pan-zoom-locked', 'highlighted-entities', 'hidden-entities', 'panned-entities', 'zoomed-entities'];
        },
        enumerable: true,
        configurable: true
    });
    CustomElement.prototype.connectedCallback = function () {
        if (!this.wpId)
            return;
        this.renderPvjs();
    };
    CustomElement.prototype.attributeChangedCallback = function () {
        if (!this.wpId)
            return;
        this.renderPvjs();
    };
    CustomElement.prototype.basicSetter = function (name, val) {
        var kebabCased = lodash_1.kebabCase(name);
        if (val) {
            this.setAttribute(kebabCased, val);
        }
        else {
            this.removeAttribute(kebabCased);
        }
    };
    CustomElement.prototype.basicGetter = function (name) {
        var kebabCased = lodash_1.kebabCase(name);
        return this.getAttribute(kebabCased);
    };
    CustomElement.prototype.boolGetter = function (name) {
        var kebabCased = lodash_1.kebabCase(name);
        return this.hasAttribute(kebabCased);
    };
    Object.defineProperty(CustomElement.prototype, "wpId", {
        get: function () {
            return this.basicGetter('wpId');
        },
        set: function (val) {
            this.basicSetter('wpId', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomElement.prototype, "version", {
        get: function () {
            return this.basicGetter('version') || 0;
        },
        set: function (val) {
            this.basicSetter('version', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomElement.prototype, "showPanZoomControls", {
        get: function () {
            return this.boolGetter('showPanZoomControls');
        },
        set: function (val) {
            this.basicSetter('showPanZoomControls', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomElement.prototype, "detailPanelEnabled", {
        get: function () {
            return this.boolGetter('detailPanelEnabled');
        },
        set: function (val) {
            this.basicSetter('detailPanelEnabled', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomElement.prototype, "panZoomLocked", {
        get: function () {
            return this.boolGetter('panZoomLocked');
        },
        set: function (val) {
            this.basicSetter('panZoomLocked', val);
        },
        enumerable: true,
        configurable: true
    });
    CustomElement.prototype.arrayGetter = function (name) {
        var attr = this.basicGetter(name);
        if (attr)
            return attr.split(',');
        else
            return [];
    };
    CustomElement.prototype.arraySetter = function (name, val) {
        var toSet = val.reduce(function (acc, el, i) { return "" + acc + el + (i === val.length - 1 ? '' : ','); }, '');
        this.basicSetter(name, toSet);
    };
    Object.defineProperty(CustomElement.prototype, "highlightedEntities", {
        get: function () {
            var highlightedEntities = this.arrayGetter('highlightedEntities');
            return highlightedEntities.map(function (singleHighlighted) {
                var split = singleHighlighted.split(':');
                return {
                    entityId: split[0],
                    color: split[1],
                };
            });
        },
        set: function (val) {
            var toSet = val.map(function (el) { return el.entityId + ":" + el.color; });
            this.arraySetter('highlightedEntities', toSet);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomElement.prototype, "hiddenEntities", {
        get: function () {
            return this.arrayGetter('hiddenEntities');
        },
        set: function (val) {
            this.arraySetter('hiddenEntities', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomElement.prototype, "zoomedEntities", {
        get: function () {
            return this.arrayGetter('zoomedEntities');
        },
        set: function (val) {
            this.arraySetter('zoomedEntities', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomElement.prototype, "pannedEntities", {
        get: function () {
            return this.arrayGetter('pannedEntities');
        },
        set: function (val) {
            this.arraySetter('pannedEntities', val);
        },
        enumerable: true,
        configurable: true
    });
    CustomElement.prototype.highlightOn = function (entityId, color) {
        this.highlightedEntities = this.highlightedEntities
            .filter(function (single) { return single.entityId !== entityId; })
            .concat([{ entityId: entityId, color: color }]);
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.highlightOff = function (entityId) {
        this.highlightedEntities = this.highlightedEntities.filter(function (single) { return single.entityId !== entityId; });
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.toggleHighlight = function (entityId, color) {
        var isHighlighted = !!this.highlightedEntities
            .filter(function (single) { return single.entityId === entityId; })[0];
        if (isHighlighted)
            this.highlightOff(entityId);
        else
            this.highlightOn(entityId, color);
    };
    ;
    CustomElement.prototype.resetHighlighted = function (exclude) {
        if (exclude === void 0) { exclude = []; }
        this.highlightedEntities = this.highlightedEntities
            .filter(function (single) { return exclude.indexOf(single.entityId) > -1; });
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.hide = function (entityId) {
        this.hiddenEntities = this.hiddenEntities
            .filter(function (single) { return single === entityId; })
            .concat([entityId]);
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.show = function (entityId) {
        this.hiddenEntities = this.hiddenEntities.filter(function (single) { return single !== entityId; });
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.toggleHidden = function (entityId) {
        var isHidden = this.hiddenEntities.indexOf(entityId) > -1;
        if (isHidden)
            this.show(entityId);
        else
            this.hide(entityId);
    };
    ;
    CustomElement.prototype.resetHidden = function (exclude) {
        if (exclude === void 0) { exclude = []; }
        this.hiddenEntities = exclude.slice();
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.zoomOn = function (entityId) {
        var toZoom;
        if (Array.isArray(entityId))
            toZoom = entityId;
        else
            toZoom = [entityId];
        this.zoomedEntities = toZoom;
        this.pannedEntities = toZoom;
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.resetZoom = function () {
        this.zoomedEntities = [];
        this.pannedEntities = [];
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.panTo = function (entityId) {
        var toPan;
        if (!Array.isArray(entityId))
            toPan = [entityId];
        else
            toPan = entityId;
        this.pannedEntities = toPan;
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.resetPan = function () {
        this.pannedEntities = [];
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.reset = function () {
        this.pannedEntities = [];
        this.zoomedEntities = [];
        this.hiddenEntities = [];
        this.highlightedEntities = [];
        this.renderPvjs();
    };
    ;
    CustomElement.prototype.renderPvjs = function () {
        var _this = this;
        var props = CustomElement.observedAttributes.reduce(function (acc, singleAttr) {
            var camelCased = lodash_1.camelCase(singleAttr);
            return __assign({}, acc, (_a = {}, _a[camelCased] = _this[camelCased], _a));
            var _a;
        }, {});
        ReactDOM.render(React.createElement(Pvjs_1.Pvjs, __assign({}, props, { onReady: this.onReady })), this);
    };
    return CustomElement;
}(HTMLElement));
exports.CustomElement = CustomElement;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/WebComponent/CustomElement.js
// module id = 477
// module chunks = 0